import { Route } from "vue-router";

export enum EntityTypes {
  CHAT_ID = 'CHAT_ID',
  BOT_ID = 'BOT_ID',
  CHANNEL_ID = 'CHANNEL_ID',
  USER_ID = 'USER_ID',
}

export type EntityCardStructure = {
  id: string | number
  title: string
  avatar: string
}

export type EntitiesListLocalData = (() => Promise<Array<EntityCardStructure>>) | Promise<Array<EntityCardStructure>>

export type EntitiesList = Record<EntityTypes, (selectedId?: EntityCardStructure['id']) => Promise<Array<EntityCardStructure>>>

export type SelectedEntitiesInput = Array<{type: EntityTypes, data: EntitiesListLocalData, selectedId: null | EntityCardStructure['id'] }>

export type AdditionalReplacerData = {
  replacerFn?: (newRoute: string, route: Route) => string,
  onWizardFinish?: (resultPath: string, selectMap: SelectedEntitiesInput, route: Route) => void
}
